var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":"","pt-lg-16":""}},[_c('v-flex',{attrs:{"xs12":"","pt-lg-16":""}},[_c('Donation')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }